
// Configuration file for PointSails application


const COOKIE_PREFIX = 'sail_quoter_';

const config = {
    COOKIE_PREFIX: COOKIE_PREFIX,
    SAIL_SELECTION_KEY_FORMAT: '{userId}_{groupId}_{boatId}_{sailId}',
    USER_COOKIE_KEY: 'user_data',
    IS_LOGGED_IN_KEY: 'is_logged_in',
    LAST_ENSURE_USER_KEY: 'last_ensure_user_timestamp',
    COOKIE_EXPIRY_DAYS: 7,
    SESSION_KEY: `session`,
    LAST_ACTIVITY_KEY: `last_activity`,
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001',
    //API_ENDPOINTS: {
    //    BOAT: '/api/boat',
    //    QUOTE: {
    //        CREATE: '/api/quote-create-anon',
    //        UPDATE: '/api/quote-update-headsail',
    //        GET: '/api/quote',
    //        OPTIONS: '/api/quote-options'
    //    }
    //},
    RETRY: {
        MAX_ATTEMPTS: 5,
        INITIAL_DELAY: 1000,
        MAX_DELAY: 5000,
        MAX_TOTAL_TIME: 25000,
        BACKOFF_FACTOR: 2
    }
} as const;

// Debug log removed for production

export default config;